document.addEventListener('DOMContentLoaded',()=>{
if(document.querySelector('.gwb-mobile-buy'))return;
const form=document.getElementById('AddToCartForm');
if(!form)return;
const source=form.querySelector('button[type="submit"]');
if(!source)return;
const bar=document.createElement('div');bar.className='gwb-mobile-buy';
const price=document.createElement('strong');
const button=document.createElement('button');button.type='button';
bar.append(price,button);document.body.append(bar);
const sync=()=>{const display=document.querySelector('.engoj_price_main');price.textContent=display?display.textContent.trim():'';button.textContent=source.textContent.trim();button.disabled=source.disabled||source.classList.contains('disabled');};
sync();new MutationObserver(sync).observe(source,{attributes:true,childList:true,subtree:true});
const display=document.querySelector('.engoj_price_main');if(display)new MutationObserver(sync).observe(display,{childList:true,subtree:true});
form.addEventListener('change',()=>requestAnimationFrame(sync));
button.addEventListener('click',()=>{sync();if(!button.disabled){source.scrollIntoView({behavior:'smooth',block:'center'});source.click();}});
if('IntersectionObserver'in window)new IntersectionObserver(entries=>{bar.classList.toggle('gwb-mobile-buy-visible',!entries[0].isIntersecting);},{threshold:0}).observe(source);
});

/* GWB audit 2026-10-26: normalize legacy Slick ARIA without changing slider behavior. */
document.addEventListener('DOMContentLoaded',function(){
  function syncSlickAccessibility(){
    document.querySelectorAll('.slick-slider').forEach(function(slider){
      slider.setAttribute('role','region');
      slider.setAttribute('aria-roledescription','carousel');
      slider.removeAttribute('aria-live');
      var track=slider.querySelector('.slick-track');
      if(track){track.setAttribute('role','group');}
      slider.querySelectorAll('.slick-slide').forEach(function(slide){
        var hidden=slide.getAttribute('aria-hidden')==='true';
        slide.setAttribute('role','group');
        slide.setAttribute('aria-roledescription','slide');
        slide.removeAttribute('aria-describedby');
        slide.inert=hidden;
      });
      slider.querySelectorAll('.slick-dots').forEach(function(dots){
        dots.setAttribute('role','group');
        dots.setAttribute('aria-label','Choose slide');
        dots.querySelectorAll('li').forEach(function(item){
          item.removeAttribute('role');item.removeAttribute('aria-selected');item.removeAttribute('aria-controls');item.removeAttribute('aria-hidden');
        });
        dots.querySelectorAll('button').forEach(function(button,index){
          button.removeAttribute('role');
          if(!button.getAttribute('aria-label'))button.setAttribute('aria-label','Go to slide '+(index+1));
        });
      });
    });
  }
  syncSlickAccessibility();
  if(window.jQuery){jQuery(document).on('init reInit afterChange','.slick-slider',function(){requestAnimationFrame(syncSlickAccessibility);});}
});

(()=>{
  document.addEventListener('keyup',event=>{
    const target=event.target;
    if(target instanceof Element&&target.matches('.js_engo_autocomplate[data-gwb-predictive-ready="true"]'))event.stopImmediatePropagation();
  },true);
  const init=()=>{
    if(window.jQuery)window.jQuery(document).off('keyup','.js_engo_autocomplate');
    document.querySelectorAll('.js_engo_autocomplate').forEach((input,index)=>{
      if(input.dataset.gwbPredictiveReady==='true')return;
      const wrapper=input.closest('.ajax_search_wrapper');
      const panel=wrapper&&wrapper.querySelector('.js_productSearchResults');
      const list=panel&&panel.querySelector('.search-results');
      if(!wrapper||!panel||!list)return;
      input.dataset.gwbPredictiveReady='true';
      panel.classList.add('gwb-predictive-results');
      panel.classList.remove('hidden-xs');
      panel.id=panel.id||`gwb-predictive-results-${index+1}`;
      panel.setAttribute('role','region');
      panel.setAttribute('aria-label','Product suggestions');
      list.setAttribute('role','listbox');
      list.setAttribute('aria-live','polite');
      input.setAttribute('autocomplete','off');
      input.setAttribute('aria-autocomplete','list');
      input.setAttribute('aria-controls',panel.id);
      input.setAttribute('aria-expanded','false');
      let timer;
      let requestSequence=0;
      let slowTimer;
      let activeIndex=-1;
      const resultCache=new Map();
      const close=()=>{
        panel.hidden=true;
        panel.style.display='none';
        input.setAttribute('aria-expanded','false');
        input.removeAttribute('aria-activedescendant');
        activeIndex=-1;
      };
      const open=()=>{
        panel.hidden=false;
        panel.style.display='block';
        input.setAttribute('aria-expanded','true');
      };
      const addMessage=(message)=>{
        const item=document.createElement('li');
        item.className='gwb-predictive-message';
        item.setAttribute('role','option');
        item.textContent=message;
        list.replaceChildren(item);
        open();
      };
      const addSearchFallback=(term,message)=>{
        const item=document.createElement('li');
        const text=document.createElement('p');
        const link=document.createElement('a');
        item.className='gwb-predictive-message';
        item.setAttribute('role','option');
        text.textContent=message;
        link.className='gwb-predictive-all-link';
        link.href=`/search?type=product&q=${encodeURIComponent(term)}`;
        link.textContent=`View all results for “${term}”`;
        item.append(text,link);
        list.replaceChildren(item);
        open();
      };
      const formatPrice=(value)=>{
        const amount=Number(value);
        if(!Number.isFinite(amount))return '';
        if(window.Shopify&&typeof window.Shopify.formatMoney==='function'){
          return window.Shopify.formatMoney(Math.round(amount*100),window.money_format||'Rs. {{amount}}');
        }
        return new Intl.NumberFormat(document.documentElement.lang||'en-PK',{style:'currency',currency:window.shop_currency||'PKR',maximumFractionDigits:0}).format(amount);
      };
      const render=(products,term)=>{
        list.replaceChildren();
        if(!products.length){
          addMessage(`No products found for “${term}”.`);
          return;
        }
        products.forEach((product,productIndex)=>{
          const item=document.createElement('li');
          const link=document.createElement('a');
          const imageWrap=document.createElement('span');
          const image=document.createElement('img');
          const details=document.createElement('span');
          const title=document.createElement('strong');
          const meta=document.createElement('span');
          item.className='gwb-predictive-item';
          item.setAttribute('role','option');
          item.id=`${panel.id}-option-${productIndex+1}`;
          link.className='gwb-predictive-link';
          link.href=product.url;
          imageWrap.className='gwb-predictive-image';
          image.loading='lazy';
          image.width=64;
          image.height=64;
          image.alt=product.featured_image&&product.featured_image.alt?product.featured_image.alt:product.title;
          image.src=product.featured_image&&product.featured_image.url?product.featured_image.url:product.image||'';
          details.className='gwb-predictive-details';
          title.className='gwb-predictive-title';
          title.textContent=product.title;
          meta.className='gwb-predictive-meta';
          const price=formatPrice(product.price_min||product.price);
          meta.textContent=product.available===false?'Out of Stock':price;
          imageWrap.append(image);
          details.append(title,meta);
          link.append(imageWrap,details);
          item.append(link);
          list.append(item);
        });
        const allItem=document.createElement('li');
        const allLink=document.createElement('a');
        allItem.className='gwb-predictive-all';
        allLink.className='gwb-predictive-all-link';
        allLink.href=`/search?type=product&q=${encodeURIComponent(term)}`;
        allLink.textContent=`View all results for “${term}”`;
        allItem.append(allLink);
        list.append(allItem);
        open();
      };
      const runSearch=async(term)=>{
        const requestId=++requestSequence;
        const cacheKey=term.toLocaleLowerCase();
        window.clearTimeout(slowTimer);
        if(resultCache.has(cacheKey)){
          render(resultCache.get(cacheKey),term);
          return;
        }
        panel.setAttribute('aria-busy','true');
        addMessage('Searching products…');
        slowTimer=window.setTimeout(()=>{
          if(requestId===requestSequence&&input.value.trim()===term){
            addSearchFallback(term,'Network is taking longer than usual.');
          }
        },3500);
        const root=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/';
        const params=new URLSearchParams({q:term,'resources[type]':'product','resources[limit]':'6','resources[options][unavailable_products]':'last'});
        try{
          const response=await fetch(`${root}search/suggest.json?${params.toString()}`,{credentials:'same-origin',headers:{Accept:'application/json'}});
          if(!response.ok)throw new Error(`Predictive search failed: ${response.status}`);
          const data=await response.json();
          const products=data.resources&&data.resources.results&&data.resources.results.products?data.resources.results.products:[];
          resultCache.set(cacheKey,products);
          if(requestId!==requestSequence||input.value.trim()!==term)return;
          render(products,term);
        }catch(error){
          if(requestId===requestSequence&&input.value.trim()===term)addSearchFallback(term,'Search suggestions are temporarily unavailable.');
        }finally{
          if(requestId===requestSequence){
            window.clearTimeout(slowTimer);
            panel.removeAttribute('aria-busy');
          }
        }
      };
      const links=()=>Array.from(list.querySelectorAll('a'));
      const setActive=(next)=>{
        const options=links();
        if(!options.length)return;
        activeIndex=(next+options.length)%options.length;
        options.forEach((link,linkIndex)=>link.classList.toggle('is-active',linkIndex===activeIndex));
        const active=options[activeIndex];
        const option=active.closest('[role="option"]');
        if(option)input.setAttribute('aria-activedescendant',option.id||'');
        active.scrollIntoView({block:'nearest'});
      };
      input.addEventListener('input',()=>{
        window.clearTimeout(timer);
        const term=input.value.trim();
        if(term.length<2){
          requestSequence+=1;
          window.clearTimeout(slowTimer);
          close();
          return;
        }
        timer=window.setTimeout(()=>runSearch(term),150);
      });
      input.addEventListener('keydown',event=>{
        if(event.key==='Escape'){
          close();
          return;
        }
        if(event.key==='ArrowDown'||event.key==='ArrowUp'){
          event.preventDefault();
          if(panel.hidden)return;
          setActive(activeIndex+(event.key==='ArrowDown'?1:-1));
          return;
        }
        if(event.key==='Enter'&&activeIndex>=0){
          const active=links()[activeIndex];
          if(active){event.preventDefault();window.location.href=active.href;}
        }
      });
      document.addEventListener('pointerdown',event=>{
        if(!wrapper.contains(event.target))close();
      });
      close();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();
